import { render, staticRenderFns } from "./df-header.vue?vue&type=template&id=6f406732&scoped=true&"
import script from "./df-header.vue?vue&type=script&lang=js&"
export * from "./df-header.vue?vue&type=script&lang=js&"
import style0 from "./df-header.vue?vue&type=style&index=0&id=6f406732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f406732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f406732')) {
      api.createRecord('6f406732', component.options)
    } else {
      api.reload('6f406732', component.options)
    }
    module.hot.accept("./df-header.vue?vue&type=template&id=6f406732&scoped=true&", function () {
      api.rerender('6f406732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/ns-dynamic-fieldset/common/df-header.vue"
export default component.exports